(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-timeline"] && !Shopify.designMode) return;
  try {
    (function () {
    var blocks = document.querySelectorAll('.product-block--delivery-timeline');
    if (!blocks.length) return;

    var months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    function addDays(base, days) {
      var next = new Date(base.getTime());
      next.setDate(next.getDate() + days);
      return next;
    }

    function formatMonthDay(date) {
      return months[date.getMonth()] + ' ' + date.getDate();
    }

    function formatRange(baseDate, minDays, maxDays) {
      var minDate = addDays(baseDate, minDays);
      var maxDate = addDays(baseDate, maxDays);
      var minMonth = months[minDate.getMonth()];
      var maxMonth = months[maxDate.getMonth()];
      var minDay = minDate.getDate();
      var maxDay = maxDate.getDate();

      if (minMonth === maxMonth) {
        return minMonth + ' ' + minDay + '-' + maxDay;
      }

      return minMonth + ' ' + minDay + ' - ' + maxMonth + ' ' + maxDay;
    }

    var today = new Date();

    blocks.forEach(function (block) {
      var shipMin = parseInt(block.getAttribute('data-ship-min-days'), 10);
      var shipMax = parseInt(block.getAttribute('data-ship-max-days'), 10);
      var deliverMin = parseInt(block.getAttribute('data-deliver-min-days'), 10);
      var deliverMax = parseInt(block.getAttribute('data-deliver-max-days'), 10);

      if (!isFinite(shipMin)) shipMin = 0;
      if (!isFinite(shipMax)) shipMax = shipMin;
      if (shipMax < shipMin) shipMax = shipMin;

      if (!isFinite(deliverMin)) deliverMin = 0;
      if (!isFinite(deliverMax)) deliverMax = deliverMin;
      if (deliverMax < deliverMin) deliverMax = deliverMin;

      var shipRange = formatRange(today, shipMin, shipMax);
      var deliverRange = formatRange(today, deliverMin, deliverMax);
      var todayLabel = formatMonthDay(today);

      var headerValue = block.querySelector('.delivery-timeline__header-value');
      if (headerValue) headerValue.textContent = deliverRange;

      var step1 = block.querySelector('[data-step-date="1"]');
      if (step1) step1.textContent = todayLabel;

      var step2 = block.querySelector('[data-step-date="2"]');
      if (step2) step2.textContent = shipRange;

      var step3 = block.querySelector('[data-step-date="3"]');
      if (step3) step3.textContent = deliverRange;
    });

    var isTouch = false;
    if (window.matchMedia) {
      isTouch =
        window.matchMedia('(hover: none)').matches ||
        window.matchMedia('(pointer: coarse)').matches ||
        window.matchMedia('(max-width: 590px)').matches;
    }

    if (isTouch) {
     
     blocks.forEach(function (block) {
        var header = block.querySelector('.delivery-timeline__header');
        if (!header) return;

        header.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          block.classList.toggle('is-open');
        });
      });

      document.addEventListener('click', function (event) {
        blocks.forEach(function (block) {
          if (!block.contains(event.target)) {
            block.classList.remove('is-open');
          }
        });
      });
    }

    
  })();
  } catch(e) { console.error(e); }
})();

})();
